import { getInventoryExportRoute } from "@slfinrtl/ui-bff-routes"
import { useCallback } from "react"
import { base64ToBlob } from "src/common/downloadBlob/base64ToBlob"
import { downloadBlob } from "src/common/downloadBlob/downloadBlob"
import { trackEvent } from "src/components/adobeAnalytics"
import { useBff } from "src/hooks"

export const useExcelExport = () => {
	const getInventoryExport = useBff(
		getInventoryExportRoute,
		{
			body: undefined,
			pathParams: {},
			queryParams: {},
		},
		"inline",
	)

	return useCallback(async () => {
		trackEvent({ action: "export_vehicles", category: "inventory" })
		const { fileName, inventoryExport } = await getInventoryExport()
		const blob = base64ToBlob(inventoryExport, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
		downloadBlob(blob, fileName ?? "Inventory.xlsx")
	}, [getInventoryExport])
}
